import React from "react";
import { Tooltip } from "@mantine/core";

interface ZoomMapsPropType {
  zoom: number;
  onZoom: (value: number) => void;
}

function ZoomMaps({ zoom, onZoom }: ZoomMapsPropType) {
  const tooltipStyles = {
    tooltip: {
      backgroundColor: "white",
      color: "#323232",
      fontSize: "12px",
    },
  };
  const handleIncrease = () => {
    let zoomLevel = Number(zoom);
    if (zoomLevel < 16) {
      zoomLevel = zoomLevel + 1;
      onZoom(zoomLevel);
    } else {
      onZoom(16);
    }
  };
  const handleDecrease = () => {
    let zoomLevel = Number(zoom);
    if (zoomLevel > 0) {
      zoomLevel = zoomLevel - 1;
      onZoom(zoomLevel);
    } else {
      onZoom(0);
    }
  };

  return (
    <Tooltip label="ซูมแผนที่" position="left" styles={tooltipStyles}>
      <div className="flex flex-col p-1 bg-primary-contrast rounded-[10px] border-[1px] border-gray-1 shadow-z16 w-8 items-center h-auto ">
        <button className="p-1" onClick={handleIncrease}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.0026 8.66683H8.66927V12.0002C8.66927 12.3668 8.36927 12.6668 8.0026 12.6668C7.63594 12.6668 7.33594 12.3668 7.33594 12.0002V8.66683H4.0026C3.63594 8.66683 3.33594 8.36683 3.33594 8.00016C3.33594 7.6335 3.63594 7.3335 4.0026 7.3335H7.33594V4.00016C7.33594 3.6335 7.63594 3.3335 8.0026 3.3335C8.36927 3.3335 8.66927 3.6335 8.66927 4.00016V7.3335H12.0026C12.3693 7.3335 12.6693 7.6335 12.6693 8.00016C12.6693 8.36683 12.3693 8.66683 12.0026 8.66683Z"
              fill="#8E8E8E"
            />
          </svg>
        </button>
        <div className="w-full bg-gray-1 h-[1px]" />
        <button className="p-1 " onClick={handleDecrease}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.9987 8.66683H3.9987C3.63203 8.66683 3.33203 8.36683 3.33203 8.00016C3.33203 7.6335 3.63203 7.3335 3.9987 7.3335H11.9987C12.3654 7.3335 12.6654 7.6335 12.6654 8.00016C12.6654 8.36683 12.3654 8.66683 11.9987 8.66683Z"
              fill="#8E8E8E"
            />
          </svg>
        </button>
      </div>
    </Tooltip>
  );
}
export default ZoomMaps;
